import ConfirmDialog from './ConfirmDialog';

/**
 * Confirm before loading a protocol when the case already has blocks.
 * Same protocol re-applies the template; a different protocol switches then copies.
 * Both replace case blocks and clear slide–block assignments.
 */
export default function ProtocolChangeDialog({
    open,
    onConfirmReplace,
    onCancel,
}) {
    return (
        <ConfirmDialog
            open={open}
            title="Load protocol?"
            message="Loading a protocol replaces this case’s blocks from the protocol template. Case-specific edits and slide–block assignments will be cleared."
            confirmLabel="Load protocol"
            cancelLabel="Cancel"
            variant="danger"
            onConfirm={onConfirmReplace}
            onCancel={onCancel}
        />
    );
}
